import * as t from 'io-ts';

export const BookingIntentAssetCodec = t.type({
    asset_id: t.string,
    account_id: t.string,
});

export const BookingIntentResponseCodec = t.type({
    booking_intents: t.array(
        t.type({
            operation_number: t.string,
            package_code: t.string,
            vin: t.string,
            occurred_at: t.string,
            sold_to_party_country_code: t.string,
            process_flag: t.union([t.literal('D'), t.literal('I'), t.literal('C'), t.literal('R')]),
            assets: t.array(BookingIntentAssetCodec),
            invoiced_at: t.union([t.string, t.undefined]),
            delivered_at: t.union([t.string, t.undefined]),
        })
    ),
});

export type BookingIntentResponse = t.TypeOf<typeof BookingIntentResponseCodec>;
